import * as amplitude from '@amplitude/analytics-browser';
import { ViewConfigState } from './urlAttributesParser';

export enum SHARED_VIEW_TYPE {
  SHARED_VIEW = 'shared_view',
  Z_MANAGER = 'z_manager',
  STAKEHOLDER_ENGAGEMENT = 'stakeholder_engagement',
}

let CURRENT_VIEW_TYPE: SHARED_VIEW_TYPE | undefined;
let AMPLITUDE_INITIALIZED = false;

export const setCurrentViewType = (viewType: SHARED_VIEW_TYPE): void => {
  CURRENT_VIEW_TYPE = viewType;
};

export const getCurrentViewType = (): SHARED_VIEW_TYPE | undefined => {
  return CURRENT_VIEW_TYPE;
};

const determineViewType = (viewAttributes: ViewConfigState): SHARED_VIEW_TYPE => {
  let viewType: SHARED_VIEW_TYPE = SHARED_VIEW_TYPE.SHARED_VIEW;
  if (viewAttributes?.attributes?.submissionConfig) {
    viewType = SHARED_VIEW_TYPE.Z_MANAGER;
  }
  if (
    viewAttributes?.attributes?.sidebarConfig?.displaySubmittedComments ||
    viewAttributes?.attributes?.allowParentlessComments
  ) {
    viewType = SHARED_VIEW_TYPE.STAKEHOLDER_ENGAGEMENT;
  }
  return viewType;
};

export const initializeAmplitude = async (
  viewKey: string,
  viewAttributes: ViewConfigState,
): Promise<void> => {
  const viewType = determineViewType(viewAttributes);

  try {
    if (process.env.VUE_APP_AMPLITUDE_KEY) {
      // Track each view as a unique "user" in Amplitude, each is a user of the parent organization.
      const { promise: initPromise } = amplitude.init(process.env.VUE_APP_AMPLITUDE_KEY, viewKey, {
        autocapture: {
          attribution: false,
          pageViews: false,
          sessions: true,
          formInteractions: true,
          fileDownloads: false,
          elementInteractions: false,
          pageUrlEnrichment: false,
          webVitals: false,
        },
      });
      await initPromise;

      const identifyEvent: amplitude.Identify = new amplitude.Identify();
      identifyEvent.set('viewKey', viewKey);
      identifyEvent.set('viewType', viewType.toString());
      identifyEvent.set('viewPrivate', viewAttributes.attributes?.private);
      identifyEvent.set('organization', viewAttributes.orgName);
      const { promise: identifyPromise } = amplitude.identify(identifyEvent);
      await identifyPromise;

      AMPLITUDE_INITIALIZED = true;
    } else {
      console.warn('No Amplitude API key configured');
    }
  } catch (error) {
    console.error('Error initializing Amplitude:', error);
  }
};

export const trackEvent = (event: string, properties: Record<string, unknown> = {}): void => {
  if (AMPLITUDE_INITIALIZED) {
    amplitude.track(event, { ...properties, appName: 'shared_view' });
  }
};
